<template>
  <v-container>
    <v-card>
      <v-card-title>Your informations</v-card-title>
      <v-card-text>
        <div>
          <span class="subtitle-1 font-weight-medium">Susbscription Plan</span>
          : {{ subscrition_plan }}
        </div>
        <div>
          <span class="subtitle-1 font-weight-medium">Email</span> : {{ email }}
        </div>
        <div>
          <span class="subtitle-1 font-weight-medium">Words</span> :
          {{ nbrof_words }}
        </div>
        <div>
          <span class="subtitle-1 font-weight-medium">Phrases</span> :
          {{ nbrof_phrases }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn outlined rounded text> Cancel subscription </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { axios } from "../main";
export default {
  name: "Dashboard",
  data() {
    return {
      email: "",
      subscrition_plan: "",
      nbrof_words: "",
      nbrof_phrases: "",
      error_alert: false,
    };
  },
  mounted() {
    this.getUserInfos();
  },
  methods: {
    async getUserInfos() {
      try {
        let infos = await axios.get("/userInfos");
        this.email = infos.data.email;
        this.nbrof_words = infos.data.words;
        this.nbrof_phrases = infos.data.phrases;

        if (infos.trial != undefined) this.subscrition_plan = "Free trial";
        else {
          this.subscrition_plan = "PoPWord premium";
        }
      } catch (err) {
        this.error_alert = true;
      }
    },
  },
};
</script>
